module.exports = __webpack_public_path__ + "static/img/2_2_2_1.8d171eea.jpg";